export default {
  invest: {
    en: "INVEST",
    ja: "投資"
  }
}
